import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import PropTypes from "prop-types";
import DataTable from "examples/Tables/DataTable";
import { formatTableData } from "./formatTableData";
import { getExcelData } from "../catastro_almacenes/getExcelData";
import TitleCustom from "components/CustomTitle";
import CatastroAlmacenesFilters from "./DetailsDialogStoresFilters";

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function DetailsDialogStores({ open, setOpen, modalData, setModalData }) {
  const handleClose = () => {
    setOpen(false);
  };

  const selectedProvince =
    modalData.length > 0 ? modalData[0]["parish"]["canton"]["province"] : null;

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="xl"
      >
        <DialogTitle
          style={{ cursor: "move", backgroundColor: "whitesmoke" }}
          id="draggable-dialog-title"
        >
          <TitleCustom
            title="Detalles Almacenes."
            excelData={getExcelData(modalData)}
            excelName={"Administracion_de_Almacenes.xlsx"}
          ></TitleCustom>
        </DialogTitle>
        <DialogContent>
          <CatastroAlmacenesFilters
            setStores={setModalData}
            selectedIdProvince={selectedProvince ? selectedProvince["idProvince"] : null}
          ></CatastroAlmacenesFilters>
          <DataTable canSearch={true} table={formatTableData(modalData)} />
        </DialogContent>
        <DialogActions style={{ cursor: "move", backgroundColor: "whitesmoke" }}>
          <Button autoFocus onClick={handleClose}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

DetailsDialogStores.defaultProps = {
  open: false,
  setOpen: null,
  modalData: [],
  setModalData: null,
};

DetailsDialogStores.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  modalData: PropTypes.array,
  setModalData: PropTypes.func,
};
